module.exports = __webpack_public_path__ + "img/button-md-true.05798a6.png";